import { createStackedState } from "client/Misc/stackedState";
import { GlobalNavigationBarMode } from "client_legacy/TitleBar/GlobalNavigation/navigationItem";
import { AppType } from "client/Api/Apps/common";
import create, { UseStore } from "zustand";
import createVanilla, { StoreApi } from "zustand/vanilla";

export interface WorkspaceSpaceNavigationHandlerOptions {
	activate: (id: number) => void;
	canEnterEditModeInSpace: (id: number) => boolean;
	saveSpaceChangesCallback: () => Promise<void>;
	rollbackSpaceChangesCallback: () => void;
}

export type GlobalNavigationStoreData = {
	activeCriteria: GlobalNavigationCriteria | undefined;
	mode: GlobalNavigationBarMode;
	workspaceSpaceNavigationHandlerOptions: WorkspaceSpaceNavigationHandlerOptions | undefined;
	setMode(mode: GlobalNavigationBarMode): void;
	setWorkspaceSpaceNavigationHandlerOptions(options: WorkspaceSpaceNavigationHandlerOptions): void;
	setActiveCriteria(criteria: GlobalNavigationCriteria): (() => void);
	isAppStoreOpen: boolean;
	setIsAppStoreOpen: (value: boolean) => void;
};

const globalNavigationStore: StoreApi<GlobalNavigationStoreData> = createVanilla(
	(set) => {
		return {
			activeCriteria: undefined,
			mode: GlobalNavigationBarMode.Normal,
			workspaceSpaceNavigationHandlerOptions: undefined,
			setMode(mode: GlobalNavigationBarMode): void {
				set({ mode });
			},
			setWorkspaceSpaceNavigationHandlerOptions(options: WorkspaceSpaceNavigationHandlerOptions): void {
				set({ workspaceSpaceNavigationHandlerOptions: options });
			},
			setActiveCriteria: createStackedState<GlobalNavigationCriteria>(
				(activeCriteria: GlobalNavigationCriteria | undefined) => set({ activeCriteria })
			),
			isAppStoreOpen: false,
			setIsAppStoreOpen: (value: boolean) => {
				set({ isAppStoreOpen: value });
			}
		};
	}
);

export const useGlobalNavigationStore: UseStore<GlobalNavigationStoreData> = create(globalNavigationStore);

export type GlobalNavigationCriteria = {
	type: "space";
	spaceId: number;
} | {
	type: "app";
	appType: Exclude<AppType, AppType.Embed>;
} | {
	type: "embedApp";
	installedAppId: number;
} | {
	type: "settings";
} | {
	type: "search";
};
